import $api from "./index";

const MAX_SPOTIFY_TRACK_COUNT = 1000;

const getSpotifyTrackCount = async (
  embedUrl: string,
  signal?: AbortSignal
): Promise<number | null> => {
  const match = embedUrl.match(
    /^https:\/\/open\.spotify\.com\/embed\/(album|playlist)\/([a-zA-Z0-9]{22})$/
  );

  if (!match) return null;

  const [, type, id] = match;
  const response = await $api.get<{ trackCount: number | null }>(
    `/spotify/${type}/${id}/track-count`,
    { signal }
  );
  const { trackCount } = response.data;

  if (
    typeof trackCount !== "number" ||
    !Number.isInteger(trackCount) ||
    trackCount < 1 ||
    trackCount > MAX_SPOTIFY_TRACK_COUNT
  ) {
    return null;
  }

  return trackCount;
};

export default getSpotifyTrackCount;
